import { render, staticRenderFns } from "./agro-rating-icon.vue?vue&type=template&id=f5b05f9a&scoped=true&"
import script from "./agro-rating-icon.vue?vue&type=script&lang=ts&"
export * from "./agro-rating-icon.vue?vue&type=script&lang=ts&"
import style0 from "./agro-rating-icon.scss?vue&type=style&index=0&id=f5b05f9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b05f9a",
  null
  
)

export default component.exports